export enum TypeMessage {
    Personalized = 0,
    New = 1,
    Edit = 2,
    Delete = 3,
    Export = 4,
    Token = 5,
    TokenError = 6,
    TokenExpired = 7,
    FormValid = 8,
    Login = 9,
    Sync = 10,
    SyncError = 11,
    SyncListEmpty = 12,
    ListErrorSafra = 13,
    ListErrorHibrido = 14,
    ListErrorSiteOrigem = 15,
    ListErrorSiteBeneficiamento = 16,
    ListErrorPeneira = 17,
    ListErrorTipoColheita = 18,
    ListErrorStatusSilo = 19,
    ListErrorTurnoAmostragem = 20,
    ListErrorConfigRolos = 21,
    ListErrorTipoCalha = 22,
    ListErrorTipoProduto = 23,
    ListErrorTipoTratamento = 24,
    ListErrorLinhaTratamento = 25,
    ListErrorEquipUtil = 26,
    ListErrorSiloOrigem = 27,
    CalcErrorFxUmidade = 28,
    ListErrorNumControlClassif = 29,
    ListErrorMtvRepr = 30,
    ListErrorNumPassRepass = 31,
    ListErrorLinhaReprocessamento = 32,
    ListErrorTurno = 33,
    ListErrorLoteOrigem = 34,
    ListErrorDepositoOrigem = 35,
    ListErrorNumControl = 36,
    ListErrorProcesso = 37,
    ListErrorPeneiraTopo = 38,
    ListErrorPeneiraFundo = 39,
    ListErrorDestino = 40,
    ListErrorSiloDestino = 41,
    ListErrorRespTratamento = 42,
    ListErrorRespApontamento = 43,
    FormInvalid = 44,
    ListErrorGeneration = 45,
    ListPeneiraIntermediaria = 46,
    InvalidRangeDate = 47,
    InvalideRangeHour = 48,
    ListErrorSocidisco = 49,
    ListErrorApollo = 50,
    RequiredField = 51,
    CalcAlertLiquidoRegulagemCbt = 52,
    DiffDias = 53,
    ListErrorTulhaOuSiloDestinoOriginal = 54,
    ListErrorJustificativaCamara = 55,
    ListErrorPolimero = 56
}

export enum ActionMessage {
    Success = 1,
    Error = 2,
    Info = 3,
    Warning = 4
}
